import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  TableAdv,
  useFormHandler,
} from "../../../../../../../components";
import {
  DeductionName,
  deductionoprtions,
  PaymentTypeoprtions,
  startcycleopetion,
} from "../../../../../../../assets/data/projectData";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../../../hooks/useLoginUser";
import common from "../../../../../../../utils/common";
import dayjs from "dayjs";
import { mapTableRows } from "../../../../../../../utils";
import { addDeductionStart } from "../../../../../../../redux/slices/payroll/payrollSlice";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../../redux/slices/universal/fileUploadSlice";
import { fetchEmpDeduction } from "../../../../../../../redux/slices/payroll/payrollApi";
import MessageConstants from "../../../../../../../constants/messageConstants";
import { showToastMessage } from "../../../../../../../utils/toastUtil";
import { exactUTCDate } from "../../../../../../../utils/dateFormator";
const AddDeductions = ({ onClose, isOpen, fetchDeductionDeatils }) => {
  const { loading, empPayConfig } = useSelector((state) => state.payRoll);
  const { generateMonthStartToEnd, formatDate } = common;
  const dispatch = useDispatch();
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
  } = useSelector((state) => state.employee);
  const isLoading = !!loading;
  const { userData: loginUserData } = useLoginUser();
  // const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const defaultValue = {
    deductionType: "",
    deductionName: "",
    payDate: "",
    retailInvoiceNumber: "",
    invoiceNumber: "",
    attachment: [],
    onvoiceAttachment: [],
    deductionAmount: "",
    paymentType: 1,
    deductionTypeRadio: 1,
    modeofDeduction: 1,
    comments: "",
    startCycle: "",
    endCycle: "",
    instalments: "",
    numberOfInstallments: "",
  };
  const defaultRoles = {
    deductionType: { type: "select", required: true },
    deductionName: { type: "select", required: true },
    paymentType: { type: "select", required: true },
    deductionAmount: { type: "text", required: true, number: true },
    attachment: { type: "file" },
    onvoiceAttachment: { type: "file" },
  };
  const [updateRoles, setUpdateRoles] = useState(defaultRoles);
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(defaultValue, updateRoles);
  useEffect(() => {
    if (formData.paymentType === 2) {
      const rules = {
        ...updateRoles,
        numberOfInstallments: { type: "text", required: true, number: true },
      };
      setUpdateRoles(rules);
    } else {
      setUpdateRoles(defaultRoles);
    }
  }, [formData.paymentType]);
  //   const today = dayjs();
  // const endOfThisMonth = today.endOf('month');
  //   const firstLabel = `${today.format('MM-DD-YYYY')}-${endOfThisMonth.format('MM-DD-YYYY')}`;
  //    const nextMonthStart = today.add(1, 'month').startOf('month').toDate();
  //   const startCycleOptions = [
  //     {
  //        label: firstLabel,
  //      value:firstLabel,
  //      dates:{from:today.toDate(),to:endOfThisMonth.toDate()}
  //     },
  //     ...generateMonthStartToEnd(nextMonthStart, 2),
  //   ];
  const today = dayjs();
  const dayOfMonth = today.date();
  let startMonth;
  if (dayOfMonth <= 15) {
    //temporary fix to display from 2025-01-01
    startMonth = dayjs.utc("2025-01-01");
    // startMonth = today.subtract(1, "month").startOf("month");
  } else {
    //temporary fix to display from 2025-01-01
    startMonth = dayjs.utc("2025-01-01");
    // startMonth = today.startOf("month");
  }
  //temporary fix to display the 12 months
  ///////
  const endMonth = today.add(3, "month");
  const monthCount = endMonth.diff(startMonth, "month") + 1;
  const startCycleOptions = generateMonthStartToEnd(startMonth, monthCount);
  ///////
  // const startCycleOptions = generateMonthStartToEnd(startMonth.toDate(), 3);
  const [tableData, setTableData] = useState([]);

  function parseDate(dateStr, separator = "/", format = "YYMMDD") {
    const dateArray = dateStr.split(separator).map(Number);
    let yyyy, mm, dd;
    switch (format) {
      case "YYMMDD":
        [yyyy, mm, dd] = dateArray;
        break;
      case "MMDDYY":
        [mm, dd, yyyy] = dateArray;
        break;
      default:
        throw new Error(`Unsupported date format: ${format}`);
    }
    // return new Date(Date.UTC(yyyy, mm - 1, dd)).toISOString();
    return new Date(Date.UTC(yyyy, mm - 1, dd));
  }
  // Output the result
  const handleSave = () => {
    try {
      const cleanAttachments =
        Array.isArray(formData.attachment) && formData.attachment.length > 0
          ? formData.attachment
          : [];
      const selectedCycle = startCycleOptions?.find(
        (data) => data.value === formData.startCycle,
      );

      const from = selectedCycle?.dates?.from || null;
      const to = selectedCycle?.dates?.to || null;
      const fromFormated = parseDate(
        dayjs.utc(from).format("MM/DD/YYYY"),
        "/",
        "MMDDYY",
      );
      const toFormated = parseDate(
        dayjs.utc(to).format("MM/DD/YYYY"),
        "/",
        "MMDDYY",
      );
      // return;
      // console.log(
      //   "selectedCycle dates from",
      //   from,
      //   fromFormated,
      //   fromFormated.toISOString()
      // );
      // console.log(
      //   "selectedCycle dates to",
      //   to,
      //   toFormated,
      //   toFormated.toISOString()
      // );
      // return;
      const deduction = {
        employeeId: employeeProfileUiid,
        type: 1,
        name: formData?.deductionName?.value ?? formData?.deductionName,
        deductionType: formData?.deductionType,
        payDate: formData?.payDate,
        payType: formData?.paymentType,
        amounts: {
          deducted: formData?.deductionAmount,
        },
        deductionMode: formData?.modeofDeduction,
        retailInvNum: formData?.retailInvoiceNumber,
        // startCycle: { from, to },
        startCycle: { from: fromFormated, to: toFormated },
        endCycle: formData?.endCycle,
        installmentNum: formData?.numberOfInstallments,
        installments: tableData,
        taxType: formData?.deductionTypeRadio,
        comments: formData?.comments,
        addedBy: loginUserUiid,
      };
      const onSuccessCallback = () => {
        handleClosed();
        setFormData(defaultValue);
        fetchDeductionDeatils();
      };
      // return 'deduction'
      const submissionData = filterEmptyValues(deduction);
      if (cleanAttachments.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: employeeProfileUiid,
            entity: "empdeductions",
            category: "empdeductions",
            coll: "EmpDeduction",
            doc: cleanAttachments,
            onSuccess: (fileData) => {
              const upateSubmissionData = {
                ...submissionData,
                attachments: fileData
                  .filter((data) => data.key)
                  .map((data) => data.key),
              };
              dispatch(
                addDeductionStart({
                  coll: "EmpDeduction",
                  payload: upateSubmissionData,
                  onSuccess: onSuccessCallback,
                }),
              );
            },
          }),
        );
      } else {
        dispatch(
          addDeductionStart({
            coll: "EmpDeduction",
            payload: submissionData,
            onSuccess: onSuccessCallback,
          }),
        );
      }
    } catch (error) {
      console.log("error in handle save deductions", error);
      showToast("Something went wrong", "error");
    }
  };

  const handleCheckDeduction = async () => {
    const isValid = validateAllFields();
    if (!isValid) {
      showToastMessage("error", "COMMON.REQUIRED_FIELDS");
      return;
    }
    if (formData?.deductionType !== 2) {
      handleSave();
      return;
    }

    try {
      const params = {
        coll: "EmpDeduction",
        filters: {
          employeeId: { type: "NONE", value: employeeProfileUiid },
          type: { type: "NONE", value: 1 },
          deductionType: { type: "NONE", value: 2 },
          stop: { type: "NONE", value: false },
          installments: { type: "ELEM_EXISTS", value: ["payrollId", false] },
        },
      };
      const response = await fetchEmpDeduction(params);
      if (response.success) {
        showToast("Health Insurance already exists", "error");
      } else {
        handleSave();
      }
    } catch (error) {}
  };
  //   useEffect(() => {
  //     if (
  //       formData.deductionAmount &&
  //       formData.numberOfInstallments &&
  //       formData.startCycle
  //     ) {
  //       const startDateStr = formData.startCycle.value?.from;
  //       const startDate = dayjs(startDateStr, "MM/DD/YYYY");
  //       const nativeDate = startDate.toDate();
  //       const nextMonthStart = new Date(
  //         nativeDate.getFullYear(),
  //         nativeDate.getMonth() + 1,
  //         1
  //       );
  // console.log("nextMonthStart",nextMonthStart);
  //       const perMonth = (
  //         formData.deductionAmount / formData.numberOfInstallments
  //       ).toFixed(2);

  //       const cycles = [
  //         {
  //           label: formData.startCycle,
  //           value: formData.startCycle,
  //         },
  //         ...generateMonthStartToEnd(
  //           nextMonthStart,
  //           formData.numberOfInstallments - 1
  //         ),
  //       ];

  //       const updateTable =
  //         cycles.length > 0
  //           ? cycles.map((data, index) => ({
  //               schedule: `Installment ${index + 1}`,
  //               payCycle: data?.value,
  //               receivable: perMonth,
  //             }))
  //           : [];

  //       setTableData(updateTable);
  //       // setStartCycles(cycles); // optional if needed elsewhere
  //     }
  //     if (formData.deductionAmount && formData.endCycle) {
  //       const startCycles = [
  //         { label: firstLabel, value: {
  //              from:today,
  //              to:endOfThisMonth
  //         } },
  //         ...generateMonthStartToEnd(nextMonthStart, null, formData.endCycle),
  //       ];
  //       // const perMonth = (
  //       //   formData.deductionAmount / (startCycles.length || 1)
  //       // ).toFixed(2);
  //       const updateTable =
  //         startCycles.length > 0
  //           ? startCycles.map((data, index) => ({
  //               schedule: `Installment ${index + 1}`,
  //               payCycle: data?.value,
  //               receivable: formData.deductionAmount ,
  //             }))
  //           : [];

  //       setTableData(updateTable);
  //     }
  //   }, [
  //     formData.deductionAmount,
  //     formData.numberOfInstallments,
  //     formData.startCycle,
  //     formData.endCycle,
  //   ]);
  useEffect(() => {
    if (!formData.deductionAmount) return;

    const { deductionAmount, numberOfInstallments, startCycle, endCycle } =
      formData;
    const perMonth = numberOfInstallments
      ? (deductionAmount / numberOfInstallments).toFixed(2)
      : null;
    // Case 1: startCycle and numberOfInstallments are provided
    if (numberOfInstallments && startCycle) {
      const selectedCycle = startCycleOptions?.find(
        (data) => data.value === formData.startCycle,
      );

      if (!selectedCycle?.dates) return;
      const { from, to } = selectedCycle.dates;
      const MonthStart = dayjs.utc(from).startOf("month");
      const cycles = [
        // ...generateMonthStartToEnd(MonthStart.toDate(), numberOfInstallments),
        ...generateMonthStartToEnd(MonthStart, numberOfInstallments),
      ];
      const updateTable = cycles.map((data, index) => ({
        schedule: `Installment ${index + 1}`,
        payCycle: data?.dates,
        receivable: perMonth,
      }));
      setTableData(updateTable);
      return;
    }

    // Case 2: deductionAmount and endCycle are provided (fixed amount for date range)
    if (endCycle) {
      const startCycles = [
        // ...generateMonthStartToEnd(startMonth.toDate(), null, endCycle),
        ...generateMonthStartToEnd(startMonth, null, endCycle),
      ];
      // return;
      const updateTable = startCycles.map((data, index) => ({
        schedule: `Installment ${index + 1}`,
        payCycle: data?.dates,
        receivable: deductionAmount,
      }));
      setTableData(updateTable);
    }
  }, [
    formData.deductionAmount,
    formData.numberOfInstallments,
    formData.startCycle,
    formData.endCycle,
  ]);

  const installmentColumns = [
    {
      key: "schedule",
      label: "Schedule",
    },
    // { key: "payCycle", label: "Pay Cycle" },
    {
      key: "payCycle",
      label: "Pay Cycle",
      render: (row) => {
        return (
          <div>
            {/* {dayjs(row?.payCycle?.from).format("MM/DD/YYYY")} -{" "}
            {dayjs(row?.payCycle?.to).format("MM/DD/YYYY")}*/}
            {exactUTCDate(row?.payCycle?.from)} -{" "}
            {exactUTCDate(row?.payCycle?.to)}
          </div>
        );
      },
    },
    { key: "receivable", label: "Amount Received" },
  ];
  const installmetRows = mapTableRows(tableData, installmentColumns);
  const handleChangePayments = (value) => {
    handleChange("paymentType", value);
    handleChange("attachment", []);
    handleChange("onvoiceAttachment", []);
    setTableData([]);
    handleChange("numberOfInstallments", "");
    handleChange("endCycle", "");
  };
  const handleClosed = () => {
    onClose();
    setFormData(defaultValue);
    setTableData([]);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ADD DEDUCTIONS"
      width="max-w-6xl"
    >
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-6 px-2 max-w-7xl">
        <FormFieldSet
          type="select"
          title="Deduction Type"
          placeholder="Select Deduction Type"
          value={formData.deductionType}
          onChange={(value) => handleChange("deductionType", value)}
          error={errors.deductionType}
          // showButton
          options={deductionoprtions}
          // showSearch
        />
        <FormFieldSet
          // type="select"
          type="deductions"
          title="Deduction Name"
          placeholder="Select Deduction Name"
          value={formData.deductionName}
          onChange={(value) => handleChange("deductionName", value)}
          error={errors.deductionName}
          showButton
          showSearch
          // options={DeductionName}
        />
        {formData?.deductionType !== 2 && (
          <FormFieldSet
            type="datepicker"
            title="Pay Date"
            placeholder="Select Pay Date"
            value={formData.payDate}
            onChange={(value) => handleChange("payDate", value)}
            error={errors.payDate}
            showDropdown={false}
          />
        )}

        {formData.paymentType == 3 ? (
          <>
            {formData?.deductionType !== 2 && (
              <FormFieldSet
                type="text"
                title="Invoice Number"
                placeholder="Enter Invoice Number"
                value={formData.retailInvoiceNumber}
                onChange={(value) => handleChange("retailInvoiceNumber", value)}
                error={errors.retailInvoiceNumber}
              />
            )}
          </>
        ) : (
          <>
            {formData?.deductionType !== 2 && (
              <FormFieldSet
                type="text"
                title="Retail Invoice Number"
                placeholder="Enter Retail Invoice Number"
                value={formData.retailInvoiceNumber}
                onChange={(value) => handleChange("retailInvoiceNumber", value)}
                error={errors.retailInvoiceNumber}
              />
            )}
          </>
        )}

        {formData.paymentType == 3 ? (
          <>
            {formData?.deductionType !== 2 && (
              <FormFieldSet
                type="file"
                title={"Invoice Attachment"}
                placeholder="Choose File"
                value={formData.attachment}
                onChange={(value) => handleChange("attachment", value)}
                error={errors.attachment}
                multiple
              />
            )}
          </>
        ) : (
          <>
            {formData?.deductionType !== 2 && (
              <FormFieldSet
                type="file"
                title={"Attachment"}
                placeholder="Choose File"
                value={formData.attachment}
                onChange={(value) => handleChange("attachment", value)}
                error={errors.attachment}
                multiple
              />
            )}
          </>
        )}

        <FormFieldSet
          type="text"
          title="Deduction Amount"
          placeholder="Enter Deduction Amount"
          value={formData.deductionAmount}
          onChange={(value) => handleChange("deductionAmount", value)}
          error={errors.deductionAmount}
        />
        <FormFieldSet
          type="select"
          title="Payment Type"
          placeholder="Select Payment Type"
          value={formData.paymentType}
          onChange={(value) => handleChangePayments(value)}
          error={errors.paymentType}
          options={PaymentTypeoprtions}
        />
        {formData.paymentType === 2 && (
          <>
            <FormFieldSet
              type="select"
              title="Start Cycle"
              placeholder="selectStart Cycle"
              value={formData.startCycle}
              onChange={(value) => handleChange("startCycle", value)}
              error={errors.startCycle}
              options={startCycleOptions}
            />
            {/* <div></div> */}
            <FormFieldSet
              type="text"
              title="Number of Installments"
              placeholder="Enter Number of Installments"
              value={formData.numberOfInstallments}
              onChange={(value) => {
                handleChange("numberOfInstallments", value);
                if (!value) {
                  setTableData([]);
                }
              }}
              error={errors.numberOfInstallments}
            />
            <div className="p-1 border-[1px] border-neutrals-200 max-h-[40vh] overflow-auto col-span-2 XL:col-span-3">
              <TableAdv
                tableId={`employee_payments_deduction_adddeduction1`}
                columns={installmentColumns}
                rows={installmetRows}
                hideToolBar
              />
            </div>
            {/* <div></div> */}
          </>
        )}
        {formData.paymentType !== 3 && (
          <>
            <FormFieldSet
              type="datepicker"
              title="End Cycle"
              placeholder="Select End Cycle Date"
              value={formData.endCycle}
              onChange={(value) => handleChange("endCycle", value)}
              error={errors.endCycle}
              minDate={dayjs().startOf("day")}
              showDropdown={false}
            />
            {/* <FormFieldSet
              type="textArea"
              title="Installments"
              placeholder="Enter Number of Installments"
              value={formData.instalments}
              onChange={(value) => handleChange("instalments", value)}
              error={errors.instalments}
            /> */}
            <div className="p-1 border-[1px] border-neutrals-200 max-h-[40vh] overflow-auto col-span-2 xl:col-span-3">
              <TableAdv
                tableId={`employee_payments_deduction_adddeduction2`}
                columns={installmentColumns}
                rows={installmetRows}
                hideToolBar
              />
            </div>
          </>
        )}
        {/* {formData.paymentType === 1 && (
          <>
            <div></div>
            <div></div>
          </>
        )} */}
        <FormFieldSet
          type="radio"
          title="Tax Deduction"
          placeholder="Deduction Type"
          options={[
            { label: "Pre-Tax Deduction", value: 1 },
            { label: "Post-Tax Deduction", value: 2 },
          ]}
          value={formData.deductionTypeRadio}
          onChange={(event) =>
            handleChange("deductionTypeRadio", event.target.value)
          }
          name="DeductionType"
        />
        <FormFieldSet
          type="radio"
          title="Mode of Deduction"
          placeholder="Select Mode"
          options={[
            { label: "Parallel Deduction", value: 1 },
            { label: "One after another", value: 2 },
          ]}
          value={formData.modeofDeduction}
          onChange={(event) =>
            handleChange("modeofDeduction", event.target.value)
          }
          error={errors.modeofDeduction}
          name="ModeofDeduction"
        />

        <div className="col-span-2 XL:col-span-3">
          <FormFieldSet
            type="textArea"
            title="Comments"
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
          />
        </div>
      </div>
      <div className="flex justify-end gap-3 mt-8">
        <Button title={"Cancel "} variant="outlined" onClick={handleClosed} />
        <Button title={"Save"} onClick={handleCheckDeduction} />
      </div>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </Modal>
  );
};

export default AddDeductions;
